import React from 'react';
import PropTypes from 'prop-types'
import { Navigation, Pagination, Autoplay, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { SwiperWrap, SwiperBtnGroup } from './swiper.stc'
import './swiper.css'

const SwiperSlider = ({ children, options, ...props }) => {
	const date = new Date().getTime();
	const prevClass = `prev-${date}`;
	const nextClass = `next-${date}`;
	const sliderOptions = {
		modules: [Navigation, Pagination, A11y, Autoplay],
		slidesPerView: 3,
		spaceBetween: 30,
		loop: false,
		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
		},
		watchSlidesProgress: true,
		...options,
		navigation: options?.navigation
			? {
				prevEl: `.${prevClass}`,
				nextEl: `.${nextClass}`,
			}
			: false,
		pagination: options?.pagination ? { clickable: true } : false,
	};


	return (
		<SwiperWrap {...props}>
			<Swiper {...sliderOptions}>
				{children}
			</Swiper>
			{sliderOptions.navigation && (
				<SwiperBtnGroup>
					<button
						type="button"
						className={`swiper-btn swiper-custom-prev ${prevClass}`}
					>
						<FiArrowLeft />
					</button>
					<button
						type="button"
						className={`swiper-btn swiper-custom-next ${nextClass}`}
					>
						<FiArrowRight />
					</button>
				</SwiperBtnGroup>
			)}
		</SwiperWrap>
	)
}

export { SwiperSlide };

SwiperSlider.propTypes = {
	children: PropTypes.node.isRequired
}

export default SwiperSlider; 